<template>
  <el-container class="shop">
    <el-header style="height:50px;padding: 15px 19px 0px;background:#f7f7f7">
      <header-crunb style="font-size:1rem;font-weight:700" :crumbList="crumbList"></header-crunb>
    </el-header>
    <el-main style="background:white">
      <template>
        <div>
          <el-form :inline="true" class="form-bottom">
            <el-form-item label="年级  :" style="font-weight:700;font-size:1rem">
              <el-select @change="classList" v-model="grade" placeholder="请选择年级" style="width:170px" clearable
                         @clear="getclearuser">
                <el-option v-for="(item,index) in getGradeList" :key="index" :label="item.gradeName"
                           :value="item.grade"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="班级  :" style="font-weight:700;font-size:1rem">
              <el-select v-model="classCode" placeholder="请选择班级" style="width:170px" clearable @clear="getclear">
                <el-option v-for="(item,index) in getClassList" :key="index" :label="item.className"
                           :value="item.classCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名  :" style="font-weight:700;font-size:1rem">
              <el-input v-model.trim="keyword" placeholder="请输入姓名..." style="width:170px" clearable @clear="getclear">
              </el-input>
            </el-form-item>
            <el-form-item label="学号  :" style="font-weight:700;font-size:1rem">
              <el-input v-model.trim="studentNum" placeholder="请输入学号..." style="width:170px" clearable
                        @clear="getclear"></el-input>
            </el-form-item>
            <el-button style="background:#21caaa;color:#fff" @click="search">查询</el-button>

            <el-button style="float:right;background:#21caaa;color:#fff" @click="dialogVisible = true">批量充值</el-button>
            <el-button style="float:right;background:#21caaa;color:#fff" @click="onLoad">下载模板</el-button>
            <!-- <el-button type="primary" @click="dialogVisibleFind = true" style="float:right">扫码查找学生</el-button> -->
          </el-form>
        </div>
      </template>
      <!-- 扫码查找学生 -->
      <el-dialog :visible.sync="dialogVisibleFind" width="30%" center>
        <span>
          <el-form>
            <el-form-item>
              <el-input v-model.trim="qrcode" placeholder="单行输入" ref="sm_input" :autofocus="true" @input="inputSaoMa">
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">请扫描二维码</span>
        </span>
      </el-dialog>
      <!-- 批量充值 -->
      <el-dialog style="text-align: center" title="批量充值" :visible.sync="dialogVisible" width="40%">

        <span>
          <el-upload class="upload-demo" :before-upload="beforeUpload" ref="upload" drag :on-success="upSuccess"
                     :on-error="upError" :on-change="upChange" name="importExcel"
                     action="/tree-web/score-order/batchScoreRecharge" :file-list="fileList" multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件，且不超过10M</div>
          </el-upload>
        </span>
        <!-- <span style="display:flex;justify-content: space-around;">
           <el-button type="primary"  @click="onFileChanged">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
        </span> -->

      </el-dialog>
      <el-dialog style="text-align: center" title="批量充值" :visible.sync="dialogVisiblechenggong" width="50%">
        <!-- <span>
          <div style="float:right">
            <el-button icon="el-icon-plus" type="primary" @click="onSelectFile">选择文件</el-button>

          </div>
          <input
            style="left:-9999px;position:absolute;"
            type="file"
            @change="onFileChanged"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            id="fileInput"
            ref="fileInput"
            mulitple
          />
        </span> -->
        <span>
          <el-table :data="importResultRows" style="width: 100%" row-key="id"
                    :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="xjh" label="学籍号" width="180" center></el-table-column>
            <el-table-column prop="userName" label="姓名" width="180"></el-table-column>
            <el-table-column prop="score" label="积分"></el-table-column>
          </el-table>
        </span>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span> -->
      </el-dialog>

      <!-- 学生详情 -->
      <div class="table-phone" @request="onRequest">
        <div class="phone" v-for="(item, id) in list" :key="item.id">
          <div class="img-group">
            <img :src="getUserLogo(item)" alt />
            <div class="img-tip">{{ item.userName }}</div>
          </div>
          <span class="deposit" @click="deposit(item)">充 值</span>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisibleDeposit" width="35%" @close="onCloseDialog">
        <span>
          <el-tabs type="border-card" stretch tab-position="top">
            <el-tab-pane label="二维码扫码" style="position:relative">
              <div class="red">
                <div style="margin-bottom:0.8rem">
                  学生姓名:
                  <span class="red">{{ form.userName }}</span>
                </div>
                <div style="float:right;position: absolute;right:0;top:0">
                  <div style="margin-bottom:0.8rem;text-align:left">
                    班级:
                    <span class="red">{{ form.gradeName }}{{ form.className }}</span>
                  </div>
                  <div style="text-align: left">
                    总积分:
                    <span class="blue">{{ depositscore }}分</span>
                  </div>
                </div>

                <div>
                  学号:
                  <span class="red">{{ form.studentNum }}</span>
                </div>
              </div>
              <div class="foot">
                卡片编号
                <div style="margin-top:0.4rem">
                  <el-form>
                    <el-form-item>
                      <el-input v-model.trim="cardCode" @change="cardSaoMa" ref="sm_input" :autofocus="true" clearable>
                      </el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
              <div style="margin-top:0.4rem !important">请扫描二维码...</div>
              <div>
                积分:
                <i>{{ cardScore }}分</i>
                <span class="dialog-footer">
                  <el-button style="background-color:#21caa8;color:#fff" @click="DepositHandleCard">充 值</el-button>
                  <el-button style="background-color:#99989b;color:#fff" @click="dialogVisibleDeposit = false">取 消
                  </el-button>
                </span>
              </div>
            </el-tab-pane>
            <el-tab-pane label="手动输入积分" style="position:relative">
              <div class="red">
                <div style="margin-bottom:0.8rem">
                  学生姓名:
                  <span class="red">{{ form.userName }}</span>
                </div>
                <div style="float:right;position: absolute;right:0;top:0">
                  <div style="margin-bottom:0.8rem">
                    班级:
                    <span class="red">{{ form.gradeName }}{{ form.className }}</span>
                  </div>
                  <div style="text-align: left">
                    总积分:
                    <span class="blue"> {{depositscore}}分</span>
                  </div>
                </div>
                <div>
                  学号:
                  <span class="red">{{ form.studentNum }}</span>
                </div>
              </div>
              <div class="foot">
                请输入总积分
                <div style="margin-top:0.4rem">
                  <el-form>
                    <el-form-item>
                      <el-input v-model.trim="handScore" placeholder="请输入积分..." clearable></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
              <span class="dialog-footer">
                <el-button style="background-color:#21caa8;color:#fff" @click="DepositHandleHand">充 值</el-button>
                <el-button style="background-color:#99989b;color:#fff" @click="dialogVisibleDeposit = false">取 消
                </el-button>
              </span>
            </el-tab-pane>
          </el-tabs>
        </span>
      </el-dialog>
    </el-main>
    <!-- 充值成功弹框 -->
    <el-dialog id="time" :visible.sync="dialogVisibleSuccess" width="20%">
      <div style="display:flex;flex-direction: column;justify-content: center;align-items: center;">
        <img style="border:none;width:120px;height:120px" src="../../../../assets/image/other/chenggong.png" alt />
        <div style="color:#1ccea6;margin-top: 1rem">充值成功!</div>
      </div>
    </el-dialog>
    <!-- 充值失败弹框 -->
    <el-dialog :visible.sync="dialogVisibleFail" width="20%">
      <div style="display:flex;flex-direction: column;justify-content: center;align-items: center;">
        <img style="border:none;width:120px;height:120px" src="../../../../assets/image/other/shibai.png" alt />
        <div style="color:black;margin-top: 1rem;">充值失败!</div>
      </div>
    </el-dialog>

    <!-- 页码 -->
    <pagination :pageObj="pageObj" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
    </pagination>
  </el-container>
</template>

<script>
import HeaderCrunb from "@/components/HeaderCrunb.vue";
import PopupDel from "@/components/PopupDel.vue";
import Pagination from "@/components/Pagination.vue";
import { postData, postJson, getData, postFile } from "../../../../http/fetch";
import { mapState } from "vuex";
import woman from "@/assets/image/other/woman_stu.png"
import man from "@/assets/image/other/man_stu.png"
import router from "../../../../router";
export default {
  components: {
    HeaderCrunb,
    Pagination,
    PopupDel,
  },
  data() {
    return {
      pageObj: {
        current: 1,
        total: 0,
        size: 40,
      },
      list: [],
      total: 0,
      depositscore: "",
      getGradeList: [],
      getClassList: [],
      form: {
        userName: '',
        gradeName: '',
        className: '',
        studentNum: '',
        currScore: '',
        userId: '',
      },
      cardCode: '',
      schoolCode: '',
      pageNum: "",
      pageSize: "",
      score: 0,
      gradeName: '',
      grade: "",
      classCode: "",
      className: '',
      userName: "",
      userCode: '',
      keyword: '',
      xjh: "",
      studentNum: '',
      currScore: 0,
      handScore: "",
      cardScore: "",
      studentId: "",
      dialogVisible: false,
      dialogVisibleDeposit: false,
      dialogVisibleFind: false,
      dialogVisibleSuccess: false,
      dialogVisibleFail: false,
      dialogVisiblechenggong: false,
      isShow: false,
      isReadOnly: false,
      qrcode: '',
      importResultRows: [],
      fileList: [],
    }
  },
  computed: {
    ...mapState(["userInfo", "setdepositInfo"]),
    crumbList() {
      return [
        { path: "", name: "查找学生", id: 1 },

      ];
    },

  },

  methods: {
    //卡号充值
    DepositHandleCard() {
      this.dialogVisibleDeposit = false
      postJson("/score-order/saveScoreRecharge", {
        schoolCode: this.userInfo.schoolCode,
        score: this.cardScore,
        userId: this.form.userId,
        cardCode: this.userInfo.cardCode,
      }).then(() => {
        this.dialogVisibleSuccess = true
        var second = 3
        function showTime() {
          second--;
          if (second <= 0) {
            this.dialogVisibleSuccess = false
            clearInterval(timer)
          }
        }
        showTime();
        var timer = setInterval(showTime, 1000);
      }).catch(() => {

        this.dialogVisibleFail = true
        var second = 3
        function showTime() {
          second--;
          if (second <= 0) {
            clearInterval(timer)
            this.dialogVisibleFail = false
          }
        }
        var timer = setInterval(showTime, 1000);
      })
    },
    //手动充值
    DepositHandleHand() {
      this.dialogVisibleDeposit = false
      postJson("/score-order/saveScoreRecharge", {
        schoolCode: this.userInfo.schoolCode,
        score: this.handScore,
        userId: this.form.userId,
        cardCode: this.userInfo.cardCode,
      }).then(() => {
        this.dialogVisibleSuccess = true
        var second = 3
        function showTime() {
          second--;
          if (second <= 0) {
            this.dialogVisibleSuccess = false
            clearInterval(timer)
          }
        }
        showTime();
        var timer = setInterval(showTime, 1000);
      }).catch(() => {
        this.dialogVisibleFail = true
        var second = 3
        function showTime() {
          second--;
          if (second <= 0) {
            clearInterval(timer)
            this.dialogVisibleFail = false
          }
        }
        var timer = setInterval(showTime, 1000);
      })
    },
    // 充值卡片详情
    onRequest() {
      postJson("/score-order/getUserScoreInfoList", {
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
        schoolCode: this.userInfo.schoolCode,
        grade: this.grade,
        classCode: this.classCode,
      }).then((res) => {
        this.list = res.records;
        this.pageObj.total = res.total;
      })
    },
    search() {
      postJson("/score-order/getUserScoreInfoList", {
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
        schoolCode: this.userInfo.schoolCode,
        grade: this.grade,
        keyword: this.keyword,
        classCode: this.classCode,
        studentNum: this.studentNum,
      }).then((res) => {
        this.list = res.records;
        this.pageObj.total = res.total;
      })
    },
    onCloseDialog() {
      this.cardCode = "",
        this.handScore = "",
        this.cardScore = ""

    },
    //年级下拉框

    GradeList() {
      return postData("/school/getGradeList", {
        schoolCode: this.userInfo.schoolCode,
      }).then((res) => {

        this.getGradeList = res;
        this.grade = this.getGradeList[0].grade
      })
    },
    //班级下拉框
    classList() {
      return getData("/school/getClassInfoList", {
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
        grade: this.grade,
        schoolCode: this.userInfo.schoolCode,
      }).then((res) => {
        this.getClassList = res;
        if (this.getClassList.length > 0) {
          this.classCode = this.getClassList[0].classCode
        } else {
          this.classCode = null;
        }

      })
    },
    getUserLogo(item) {
      if (item.userLogo) {
        return item.userLogo
      } else {
        if (item.userSex == '女') {
          return woman
        } else {
          return man
        }
      }
    },
    deposit(item) {
      this.dialogVisibleDeposit = true
      this.form = item
      postJson("/score-order/getUserScoreInfoList", {
        pageNum: 1,
        pageSize: 1,
        schoolCode: this.userInfo.schoolCode,
        studentId: this.form.userId,
      }).then((res) => {
        this.depositscore = res.records[0].currScore;
      })
    },

    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize;
      this.onRequest(1, pageSize);
    },
    handleCurrentChange(current) {
      this.pageObj.current = current;
      this.onRequest();
    },
    onSelectFile() {
      document.getElementById("fileInput").click();
    },

    // onFileChanged(){
    //    this.$refs.upload.submit();
    // },

    // onFileChanged() {
    //   //console.log(e)

    //   //this.dialogVisible = false
    //  // let form = new FormData();
    //   //form.append("importExcel", e.target.files[0]);
    //   //console.log(e.target.files[0])
    //   postFile("/score-order/batchScoreRecharge",importExcel)
    //     .then((res) => {
    //      // this.dialogVisiblechenggong=true
    //       this.importResultRows = res.success
    //       console.log(res.data)
    //       this.$message({
    //         type: 'success',
    //         message: '上传成功'
    //       })
    //     })
    //     .catch((e) => {

    //       this.$message({
    //         type: 'info',
    //         message: '上传失败'
    //       })
    //     });
    // },
    //上传之前
    beforeUpload(file) {
      const fileSuffix = file.name.substring(
        file.name.lastIndexOf('.') + 1
      );
      const whiteList = ['xls', 'xlsx'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message({
          type: 'error',
          message: '上传文件只能是 xls/xlsx 格式',
          showClose: true,
          offset: 80,
        });
        this.fileList = [];
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message({
          type: 'error',
          message: '上传文件不能超过10MB',
          showClose: true,
          offset: 80,
        });
        return false;
      }
    },
    //上传成功
    upSuccess(res) {
      this.importResultRows = res.data.success
      this.dialogVisible = false
      this.$message({
        type: 'success',
        message: '充值成功',
        showClose: true,
        offset: 80,
      })
      setTimeout(() => {
        this.dialogVisiblechenggong = true
      }, 1000)
    },
    //上传失败
    upError() {
      this.$message({
        type: 'error',
        message: '充值失败',
        showClose: true,
        offset: 80,
      });
    },
    //上传的文件改变时
    upChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }
    },
    //下载模板
    onLoad() {
      getData("/score-order/downloadExamTemplate", {
        grade: this.grade,
        classCode: this.classCode,
        keyword: this.keyword,
        studentNum: this.studentNum
      }, { responseType: 'blob' }).then((res) => {

        const blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=GBK' })
        const download = document.createElement('a')
        download.style.display = 'none'
        download.href = URL.createObjectURL(blob)
        download.download = '批量充值.xls'
        document.body.appendChild(download)
        download.click()
        URL.revokeObjectURL(blob)
        document.body.removeChild(download)

      }).catch((e) => {

        //console.log(e)
      })

    },
    //扫码查找学生

    asycreated() {
      let saomacode = ""
      var _this = this;
      document.onkeydown = function (e) {

        let lastTime, nextTime;
        let lastCode, nextCode;

        if (window.event) { // IE
          nextCode = e.keyCode;

        } else if (e.which) { // Netscape/Firefox/Opera
          nextCode = e.which;
        }
        if (nextCode === 13) {
          if (saomacode.length <= 10) {
            _this.cardCode = saomacode
            _this.cardSaoMa(saomacode)
          } else {
            _this.qrcode = saomacode
            _this.inputSaoMa(saomacode)
          }
          saomacode = '';
          lastCode = '';
          lastTime = '';
          return;
        }
        nextTime = new Date().getTime();
        if (!lastTime && !lastCode) {
          saomacode += e.key;
        }

        if (lastCode && lastTime && nextTime - lastTime > 30) { // 当扫码前有keypress事件时,防止首字缺失
          saomacode = e.key;
        } else if (lastCode && lastTime) {
          saomacode += e.key;
        }

        lastCode = nextCode;
        lastTime = nextTime;
      }
    },
    inputSaoMa(val) {
      console.log(`|${val}|`)
      if (val === '') return false
      this.isShow = false
      if (this.qrcode === val) {
        console.log('输入完毕')
        this.isShow = true
        this.isReadOnly = true
        //查询学生
        postJson("/score-order/getUserScoreInfoList", {
          pageNum: this.pageObj.current,
          pageSize: this.pageObj.size,
          xjh: this.qrcode.trim(),
          schoolCode: this.userInfo.schoolCode,
        }).then((res) => {
          this.list = res.records;
          //console.log(res)
          this.qrcode = '';
        })
      }
    },
    cardSaoMa(val) {
      if (val === '') return false
      this.isShow = false
      if (val && this.cardCode === val.trim()) {
        console.log('输入完毕')
        this.isShow = true
        this.isReadOnly = true
        //查询卡片积分
        getData("/card/getScoreCardByCode", {
          cardCode: this.cardCode.trim(),
          schoolCode: this.userInfo.schoolCode,
        }).then((res) => {
          //console.log(res)
          this.cardScore = res.score;
          this.qrcode = '';
        })
      }
    },
    getclear() {
      this.search();
    },
    getclearuser() {
      if (this.grade) {
        this.search();
      } else {
        this.list = []
      }
    },
    getinputValue() {
      //const element = document.getElementById('iput');
      //this.$refs['sm_input'].focus();
      //debugger
      // function step() {
      //   element.setAttribute('focus', true)
      // }

      window.requestAnimationFrame(step);

    },
  },

  async mounted() {
    this.inputSaoMa();
    this.cardSaoMa();
    this.asycreated();
    //this.getinputValue();
    await this.GradeList();
    await this.classList();
    this.onRequest();
  }
};
</script>

<style lang="less" scoped>
.img-group {
  position: relative;
  display: inline-block;
}

.img-tip {
  width: 100%;
  height: 14%;
  text-align: center;
  position: absolute;
  bottom: 0.3rem;
  background: #1a8b90;
  color: #fff;
  opacity: 0.5;
  font-size: 0.9rem;
  vertical-align: middle;
  line-height: 1.5rem;
  border-radius: 0 0 0.8rem 0.8rem;
}

.table-phone {
  display: flex;
  flex-wrap: wrap;
}

img {
  width: 8rem;
  height: 9.5rem;
  border-radius: 0.8rem;
  overflow: hidden;
  border: #75c2b1 2px solid;
}

.phone {
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 8rem;
  height: 13rem;
  margin-right: 0.9rem;
  margin-left: 0.9rem;
  font-size: 1rem;
}

.deposit {
  color: #ffcf3e;
  font-weight: 700;
  font-size: 1.2rem;
  text-decoration: underline;
  cursor: pointer;
}

.red {
  color: #8b888b;
  font-size: 15px;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem !important;
}

.blue {
  color: #51c3a6;
}

.foot {
  font-size: 15px;
  font-weight: 500;
  color: #676769;
}

.dialog-footer {
  display: flex;
  justify-content: space-around;
}

.form-bottom {
  border-bottom: 0.1rem solid #f2f2f2;
  width: 100%;
}
</style>
